// extracted by mini-css-extract-plugin
export default {"campaigns":"Campaigns_campaigns__nMowb"};